(function (Lfl, $, undefined) {
    Lfl.Animations = Lfl.Animations || {};

    (function (Animations, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Animations, 'ElementLoadingSpinnerAnimator')) {
            return;
        }

        /**
         * Helps with adding a simple loading spinner to a given element.
         *
         * @param {jQuery} parameters.$element
         * @param {jQuery} [parameters.$target = $element] Or the element itself, if not defined.
         * @param {string} [parameters.icon = 'rotate_right']
         *
         * @memberOf Lfl.Animations
         * @lends Lfl.Animations.ElementLoadingSpinnerAnimator
         * @constructor
         */
        Lfl.Animations.ElementLoadingSpinnerAnimator = function (parameters) {
            const LOADING_VIA_SPINNER_ID_NAME = 'data-loading-via-spinner-id';

            const $element = parameters.$element;
            const $target = parameters.$target ? parameters.$target : parameters.$element;
            const icon = parameters.icon ? parameters.icon : 'rotate_right';

            /**
             * Displays the spinner loading on the element.
             *
             * TODO Later - Merge with loading-animator, code copied from showLoadingViaReplace.
             *      Upd: And moved from element-loading-animation-handler.js here. Probably call this element there.
             */
            this.start = function () {
                const loaderId = getSpinnerId();
                const $loader = $('#' + loaderId);

                if ($loader.length) {
                    // We already have the loader, it is just hidden
                    $loader.show();
                } else {
                    // We need to create a new spinner
                    const spinner = createSpinner(loaderId);

                    prependSpinnerToTarget($target, spinner);
                }
            };

            this.stop = function () {
                $('#' + getSpinnerId()).hide();
            };

            function getSpinnerId() {
                return LoadingAnimator.getLoaderId($element, LOADING_VIA_SPINNER_ID_NAME, 'via-spinner');
            }

            /**
             * @returns {string}
             */
            function createSpinner(loaderId) {
                return '<span id="' + loaderId + '" class="icon icon--left material-icons rotate">' + icon + '</span>';
            }

            /**
             * @param $target
             * @param {string} spinner The spinner html
             */
            function prependSpinnerToTarget($target, spinner) {
                $target.get(0).insertAdjacentHTML("afterbegin", spinner);
            }
        };
    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
